// extracted by mini-css-extract-plugin
export default {"form":"cocktailsearch_form__JPBH0","textInput":"cocktailsearch_textInput__xjNoK","submit":"cocktailsearch_submit__6YcaL"};